import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  onClick: () => void;
};

export default function FacilityFeaturesDialogButton({ onClick }: Props) {
  const { t } = useTranslation();
  return (
    <Link onClick={onClick} role="button" sx={{ cursor: "pointer" }}>
      {t("Learn more about available services")}
    </Link>
  );
}
